import { put, call } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import { clearUserProperties } from 'util/amplitude';
import AuthService from '../../services/AuthService';

import { recentDealListSuccess } from '../deals/actions';
import { deleteMfaLoginToken } from '../logins/actions';
import { resetUser, logoutUser } from '../user/actions';
import { userHasLoggedOut } from '../../util/sessionTimeout';

// put this saga into a separate file to break a dependency cycle between auth, user
// and dealer saga files
export function* logout() {
  const token: string | null = yield call(AuthService.getToken);
  if (token) {
    try {
      yield call(AuthService.logout);
    } catch (e) {
      // if we are getting a 401 (unauthorized), then we are already logged out.
      const isUnauthorizedError = (e as any).status === 401;
      if (!isUnauthorizedError) {
        throw e;
      }
    }
    yield call(AuthService.setToken, null);
  }
  clearUserProperties();
  yield put(resetUser());
  yield put(deleteMfaLoginToken());
  yield put(logoutUser());
  yield put(replace('/login'));

  // Reset other data
  yield put(recentDealListSuccess(null));
  userHasLoggedOut();
}
